@if (control) {
  <mat-form-field>
    @if (label()) {
      <label
        [for]="inputId"
        [ngClass]="{ 'text-red': control.invalid && (control.dirty || control.touched) }"
      >
        <span
          >{{ label() }}
          @if (isRequired && !hideRequiredMarker()) {
            <span class="required">*</span>
          }
        </span>
      </label>
    }
    <input
      matInput
      type="text"
      inputmode="decimal"
      [id]="inputId"
      [autocomplete]="autocompleteComputed()"
      [formControl]="control"
      [mask]="maskComputed()"
      thousandSeparator=","
      [prefix]="prefix()"
      [dropSpecialCharacters]="true"
      [pattern]="patternComputed()"
      [min]="min()"
      [max]="max()"
      [readonly]="readonly()"
      [placeholder]="placeholder()"
      [attr.aria-label]="ariaLabel() || null"
      [ngClass]="'text-' + alignment()"
    />
    @if (startHint()) {
      <mat-hint align="start">{{ startHint() }}</mat-hint>
    }
    @if (endHint()) {
      <mat-hint align="end">{{ endHint() }}</mat-hint>
    }
    @if (showError) {
      <mat-error>{{ getErrorMessage(errorKeys[0]) }}</mat-error>
    }
  </mat-form-field>
}
